/* src/views/jour/proto/JourTachesProto.jsx — MES TÂCHES d'Aujourd'hui,
   transcrit de docs/handoff/aujourdhui-complet.jsx (JourTachesSemaine /
   Tout / Faites). NEUF : il vient de l'ancien kanban, avec les quatre
   « à jeter » de Dimitri appliqués — plus de colonne « En cours », plus de
   swimlanes, plus d'étiquettes, plus de glisser-déposer. Trois vues :
   Ma semaine (défaut), Tout, Faites. La vue Ma semaine mêle les tâches et
   les RENDEZ-VOUS lus dans le calendrier — les rendez-vous sont pour
   l'instant des données d'exemple, la jonction CalDAV viendra dans son lot
   (la carte du bas dit l'état réel). Styles copiés tels quels. */

import React from 'react'

/* ── la barre de vues + « ＋ Une tâche » ──────────────────────────── */
export function BarreVuesTaches({ vue, onVue, nTout, nFaites, onNouvelle }) {
  // LOT 4 (décision Dimitri 2026-08-28) — la vue « Notes » (bloc-notes admin,
  // table admin_notes) revient en quatrième vue : elle avait été perdue au
  // montage du lot 3 (régression attrapée par l'inventaire lot 4).
  const st = (on) => (on
    ? { flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', gap: '6px',
        minHeight: '38px', padding: '0 13px', borderRadius: '8px', fontSize: '11.5px',
        whiteSpace: 'nowrap', background: '#fff', color: 'var(--navy-d)',
        fontWeight: '600', boxShadow: '0 1px 3px rgba(35,50,64,.12)' }
    : { flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', gap: '6px',
        minHeight: '38px', padding: '0 13px', borderRadius: '8px', fontSize: '11.5px',
        whiteSpace: 'nowrap', color: 'var(--gris)' })
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px',
      marginBottom: '12px', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', gap: '3px', background: '#eef2f6',
        borderRadius: '10px', padding: '3px', flex: '1', minWidth: '0',
        overflowX: 'auto', scrollbarWidth: 'none' }}>
        <button onClick={() => onVue('semaine')} data-testid="taches-vue-semaine"
          style={st(vue === 'semaine')}>Ma semaine</button>
        <button onClick={() => onVue('quand')} data-testid="taches-vue-tout"
          style={st(vue === 'quand')}>Tout
          <span style={{ fontSize: '9.5px', color: 'var(--gris-d)' }}>{nTout}</span>
        </button>
        <button onClick={() => onVue('faites')} data-testid="taches-vue-faites"
          style={st(vue === 'faites')}>Faites
          <span style={{ fontSize: '9.5px', color: 'var(--gris-d)' }}>{nFaites}</span>
        </button>
        <button onClick={() => onVue('notes')} data-testid="taches-vue-notes"
          style={st(vue === 'notes')}>Notes</button>
      </div>
      <button onClick={onNouvelle} data-testid="taches-nouvelle"
        style={{ minHeight: '38px', padding: '0 14px', borderRadius: '10px',
          background: 'var(--terra)', border: 'none', color: '#fff', fontSize: '11.5px',
          fontWeight: '600', flexShrink: '0' }}>＋ Une tâche</button>
    </div>
  )
}

/* ── une ligne : tâche (blanche, cochable) ou rendez-vous (grise) ─── */
export function LigneTache({ heure, faite, titre, sous, sousTerra, auto, barree,
  onOuvrir, onCocher, testId }) {
  return (
    <div className="" style={{ background: '#fff', borderRadius: '12px',
      marginBottom: '6px', overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(35,50,64,.07),0 0 0 1px rgba(35,50,64,.04)' }}>
      <button onClick={onOuvrir} data-testid={testId}
        style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
          textAlign: 'left', background: '#fff', border: 'none', padding: '11px 12px',
          minHeight: '56px' }}>
        <span style={{ width: '36px', flexShrink: '0', fontSize: '11px',
          fontWeight: '600',
          color: heure ? 'var(--navy-d)' : 'transparent' }}>{heure || '—'}</span>
        <span onClick={(e) => { e.stopPropagation(); onCocher && onCocher() }}
          data-testid={testId ? `${testId}-cocher` : undefined}
          style={faite
            ? { width: '20px', height: '20px', borderRadius: '6px', flexShrink: '0',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: '#2f9e6e' }
            : { width: '20px', height: '20px', borderRadius: '6px', flexShrink: '0',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: '1.5px solid #c3cdd6', background: '#fff' }}>
          {faite && (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 6 9 17l-5-5" />
            </svg>
          )}
        </span>
        <span style={{ flex: '1', minWidth: '0' }}>
          <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
            color: barree ? 'var(--gris-d)' : 'var(--navy-d)', lineHeight: '1.4',
            ...(barree ? { textDecoration: 'line-through' } : {}) }}>{titre}</span>
          <span style={{ display: 'block', fontSize: '10px',
            color: sousTerra ? 'var(--terra-tx)' : 'var(--gris)', marginTop: '2px',
            overflow: 'hidden', textOverflow: 'ellipsis',
            whiteSpace: 'nowrap' }}>{sous}</span>
        </span>
        {auto && <span style={{ width: '6px', height: '6px', borderRadius: '50%',
          background: '#87b8e6', flexShrink: '0' }} title="créée toute seule" />}
        <span style={{ fontSize: '15px', color: 'var(--gris-d)', flexShrink: '0',
          transform: 'rotate(0deg)' }}>›</span>
      </button>
    </div>
  )
}

export function LigneRendezVous({ heure, titre, sous }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px',
      background: '#f6f8fa', borderRadius: '12px', padding: '11px 12px',
      minHeight: '56px', marginBottom: '6px' }}>
      <span style={{ width: '36px', flexShrink: '0', fontSize: '11px',
        fontWeight: '600', color: 'var(--gris)' }}>{heure}</span>
      <span style={{ width: '20px', height: '20px', borderRadius: '6px',
        flexShrink: '0', background: '#e3e8ee' }} />
      <span style={{ flex: '1', minWidth: '0' }}>
        <span style={{ display: 'block', fontSize: '12.5px', color: 'var(--gris)',
          lineHeight: '1.4' }}>{titre}</span>
        <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris-d)',
          marginTop: '2px' }}>{sous}</span>
      </span>
    </div>
  )
}

/* ── l'histogramme de la semaine (7 jours, barres empilées) ───────── */
export function SemaineBarres({ jours, onJour }) {
  return (
    <div style={{ background: '#fff', borderRadius: '16px', padding: '13px',
      marginBottom: '14px',
      boxShadow: '0 1px 3px rgba(35,50,64,.08),0 0 0 1px rgba(35,50,64,.05)' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '5px',
        height: '78px' }}>
        {jours.map((j, i) => (
          <button key={i} onClick={() => onJour(i)} data-testid={`taches-jour-${i}`}
            style={{ flex: '1', minWidth: '0', display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'flex-end', gap: '3px',
              background: 'none', border: 'none', padding: '0', height: '100%' }}>
            {j.barres.length > 0 ? (
              <span style={{ display: 'flex', flexDirection: 'column',
                justifyContent: 'flex-end', gap: '2px', width: '100%',
                maxWidth: '26px' }}>
                {j.barres.map((b, k) => (
                  <span key={k} style={{ height: '21px', borderRadius: '3px',
                    background: b }} />
                ))}
              </span>
            ) : (
              <span style={{ width: '100%', maxWidth: '26px', height: '3px',
                borderRadius: '2px', background: '#eef2f6' }} />
            )}
            <span style={{ fontSize: '9.5px',
              color: j.aujourdhui ? 'var(--navy-d)' : 'var(--gris-d)',
              ...(j.aujourdhui ? { fontWeight: '600' } : {}),
              marginTop: '4px' }}>{j.lb}</span>
            <span style={{ width: '5px', height: '5px', borderRadius: '50%',
              background: 'transparent' }} />
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: '14px', marginTop: '11px', paddingTop: '10px',
        borderTop: '1px solid var(--bord)', flexWrap: 'wrap' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '2px',
            background: '#87b8e6' }} />
          <span style={{ fontSize: '10px', color: 'var(--gris)' }}>vos tâches</span>
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '2px',
            background: '#c3cdd6' }} />
          <span style={{ fontSize: '10px', color: 'var(--gris)' }}>vos rendez-vous</span>
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '2px',
            background: '#b8412b' }} />
          <span style={{ fontSize: '10px', color: 'var(--gris)' }}>aujourd'hui</span>
        </span>
      </div>
    </div>
  )
}

/* ── les en-têtes de section ──────────────────────────────────────── */
export function SectionPoint({ point, titre, n, terra, enfants }) {
  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px',
        marginBottom: '9px' }}>
        <span style={{ width: '7px', height: '7px', borderRadius: '50%',
          background: point, flexShrink: '0' }} />
        <span style={{ flex: '1', fontSize: '12px', fontWeight: '600',
          color: terra ? 'var(--terra-tx)' : 'var(--navy-d)' }}>{titre}</span>
        <span style={terra
          ? { minWidth: '20px', height: '20px', borderRadius: '10px',
              background: 'var(--terra-bg)', color: 'var(--terra-tx)', fontSize: '10px',
              fontWeight: '600', display: 'inline-flex', alignItems: 'center',
              justifyContent: 'center', padding: '0 6px' }
          : { minWidth: '20px', height: '20px', borderRadius: '10px',
              background: '#eef2f6', color: 'var(--gris-d)', fontSize: '10px',
              fontWeight: '600', display: 'inline-flex', alignItems: 'center',
              justifyContent: 'center', padding: '0 6px' }}>{n}</span>
      </div>
      {enfants}
    </div>
  )
}

export function SectionJour({ cle, date, vide, onNouvelle, enfants, estAuj }) {
  return (
    <div style={{ marginBottom: vide ? '2px' : '16px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px',
        paddingLeft: '2px', marginBottom: vide ? '0' : '9px' }}>
        <span style={{ width: '52px', flexShrink: '0', fontSize: '11.5px',
          fontWeight: '600',
          color: estAuj ? 'var(--navy-d)' : vide ? 'var(--gris-d)' : 'var(--gris)' }}>{cle}</span>
        <span style={{ flex: '1', fontSize: '10.5px', color: 'var(--gris-d)' }}>{date}</span>
        {vide
          ? <span style={{ fontSize: '10px', color: 'var(--gris-d)',
              padding: '5px 0' }}>—</span>
          : <button onClick={onNouvelle} style={{ minHeight: '26px', padding: '0 9px',
              borderRadius: '7px', background: 'none', border: '1px solid var(--bord)',
              fontSize: '11px', color: 'var(--gris)' }}>＋</button>}
      </div>
      {enfants}
    </div>
  )
}

/* ── la carte « Votre calendrier » — texte d'ÉTAT RÉEL en prop ────── */
export function CarteCalendrier({ tag, tagClasse = 'tag t-v', sous, note }) {
  return (
    <div className="carte" style={{ margin: '14px 0 0', background: '#f6f8fa' }}
      data-testid="taches-carte-calendrier">
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px',
        flexWrap: 'wrap' }}>
        <span style={{ width: '26px', height: '26px', borderRadius: '8px',
          background: '#fff', border: '1px solid var(--bord)', color: '#5c6773',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '12px', flexShrink: '0' }}>◷</span>
        <span style={{ flex: '1', minWidth: '150px' }}>
          <span style={{ display: 'block', fontSize: '11.5px', fontWeight: '600',
            color: 'var(--navy-d)' }}>Votre calendrier</span>
          <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
            marginTop: '1px', lineHeight: '1.45' }}>{sous}</span>
        </span>
        <span className={tagClasse} style={{ flexShrink: '0' }}>{tag}</span>
      </div>
      <p className="note">{note}</p>
    </div>
  )
}
